module.exports = __webpack_public_path__ + "img/31_30.5b10a0c7.png";